import React from "react";
import { getSize } from "../../utils/size";
import { classnames, combinePrefixes } from "../../utils/text";
import { ModalHeader as OriginModalHeader } from "reactstrap";
const ModalHeader = ({
  type = 'default',
  size = 'lg', // lg, md, sm ,x-sm
  className,
  children,
  toggle,
  style = {}
}) => {
  return <>
    <OriginModalHeader
      className={
        classnames(
          combinePrefixes(`modal-header`, [type.toLowerCase(), getSize(size),]),
          className
        )
      }
      style={style}
      toggle={toggle}
    >
      {children}
    </OriginModalHeader>
  </>
}
export default ModalHeader